import { useState, useEffect } from "react";
import { offlineDb } from "@/core/offline/db";

/**
 * Diamètres extérieurs déjà saisis sur le même site que `pinId` (triés croissants).
 *
 * Extrait de DiametreSuggestions (I10) pour sortir l'accès Dexie du composant de
 * présentation. Modèle B : `pin.siteId` est accessible directement.
 */
export function useSiteUsedDiameters(pinId: string): number[] {
  const [usedDiameters, setUsedDiameters] = useState<number[]>([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const pin = await offlineDb.pins.get(pinId);
      if (!pin || cancelled) return;

      // Toutes les mesures du site (via les pins du site)
      const sitePins = await offlineDb.pins.where("siteId").equals(pin.siteId).toArray();
      const pinIds = sitePins.map((p) => p.id);
      const mesures = await offlineDb.mesures.where("pinId").anyOf(pinIds).toArray();

      const diams = new Set<number>();
      for (const m of mesures) {
        if (m.diametreExt && m.diametreExt > 0) diams.add(m.diametreExt);
      }
      if (!cancelled) setUsedDiameters([...diams].sort((a, b) => a - b));
    })();
    return () => {
      cancelled = true;
    };
  }, [pinId]);

  return usedDiameters;
}
